import type { ScreenOrderStatus } from './screen-view';
import type { ApiScreenOrderStatus } from './screen-order-status-types';

// Bestillingsstatus er nå et ekte felt på Screen-responsen fra backend
// (dabih-api #4591/#4590). Tidligere ble statusen smuglet inn i screen_name
// via et `[A]`-prefiks – det er fjernet (#13126).
//
// Mapper backend-enum til den interne web-statusen som UI-et bruker.
export function mapApiOrderStatus(status: ApiScreenOrderStatus | string | undefined): ScreenOrderStatus {
  switch (status) {
    case 'ORDERED':
      return 'ordered';
    case 'DELIVERED':
      return 'connected';
    case 'TRIAL':
    default:
      return 'none';
  }
}
